<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect" v-top-menu-scroll>
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/jinshajiangIndex">首页</el-menu-item>
        <el-submenu :index="'/jinshajiang/gasClampCombinedV2'">
          <template slot="title">全桥实时数据</template>
          <el-menu-item index="/jinshajiang/gasClampCombinedV2"> 气夹实时数据(自动选择) </el-menu-item>
          <el-menu-item index="/jinshajiang/gasClampSensor" v-if="isAdmin"> 气夹实时数据(通讯箱) </el-menu-item>
          <el-menu-item index="/jinshajiang/gasClampPLC" v-if="isAdmin"> 气夹实时数据(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/gasClampWINCC" v-if="isAdmin"> 气夹实时数据(WINCC) </el-menu-item>
          <!-- <el-menu-item index="/jinshajiang/stationClampCombinedV2"> 锚鞍室实时数据(自动选择) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationClampPLC"> 锚鞍室实时数据(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationClampWINCC"> 锚鞍室实时数据(WINCC) </el-menu-item> -->
        </el-submenu>
        <el-submenu :index="'/jinshajiang/stationMainPlc'">
          <template slot="title">主缆除湿机</template>
          <el-menu-item index="/jinshajiang/stationMainPlc/huaping"> 华坪侧主缆除湿机(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationMainPlc/lijiang"> 丽江侧主缆除湿机(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationMainWincc/huaping"> 华坪侧主缆除湿机(WINCC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationMainWincc/lijiang"> 丽江侧主缆除湿机(WINCC) </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/jinshajiang/stationAnchorPlc'">
          <template slot="title">锚室除湿机</template>
          <el-menu-item index="/jinshajiang/stationAnchorPlc/huaping"> 华坪侧锚室除湿机(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationAnchorPlc/lijiang"> 丽江侧锚室除湿机(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationAnchorWincc/huaping"> 华坪侧锚室除湿机(WINCC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationAnchorWincc/lijiang"> 丽江侧锚室除湿机(WINCC) </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/jinshajiang/stationSaddlePlc'">
          <template slot="title">鞍室除湿机</template>
          <el-menu-item index="/jinshajiang/stationSaddlePlc/huaping"> 华坪侧鞍室除湿机(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationSaddlePlc/lijiang"> 丽江侧鞍室除湿机(PLC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationSaddleWincc/huaping"> 华坪侧鞍室除湿机(WINCC) </el-menu-item>
          <el-menu-item index="/jinshajiang/stationSaddleWincc/lijiang"> 丽江侧鞍室除湿机(WINCC) </el-menu-item>
        </el-submenu>
        <el-menu-item index="/jinshajiang/currentHumidityList?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39&sortByItemCount=1"
          >湿度数据清单</el-menu-item
        >
        <el-menu-item index="/jinshajiang/currentDataTable?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39">实时数据表</el-menu-item>
        <el-menu-item index="/jinshajiang/errorRecord?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39">报警记录</el-menu-item>
        <el-submenu :index="'/jinshajiang/dataHistory?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/jinshajiang/dataHistory?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/jinshajiang/dataHistory?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="YUNNAN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main jin-sha-jiang">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>

import topMenuScroll from '../../tools/TopMenuScroll.js'
import { mapGetters } from "vuex";

export default {
  name: "jinshajiang",
  data() {
    return {
      bridgeId: "5afe37e8-98fc-416c-b5e3-26011df7fb39",
      envInfo: {
        envId: "600018c7-7d5b-4677-9a67-2d8d94d145d4",
        weather: "d421677c-bcd5-4029-9efc-3a5c201f6bb0",
        humidity: "7a918bd7-6883-4d7c-9f18-ec7a56a942a7",
        temperature: "1fc0abf2-ffb6-47be-8ec6-093ad0530679",
        weatherAbsoluteHumidity: "4875b5c6-c0f4-4a72-bb6b-7717882d6f6c",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  directives: {
    topMenuScroll,
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
    }),
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>
